module.exports = __webpack_public_path__ + "img/reference-merlin-ub.f39b37e4.jpg";